module.exports = __webpack_public_path__ + "img/dy.035d80c8.png";